module.exports = __webpack_public_path__ + "static/media/icon-esg.178814a6.svg";